import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("rc_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("rc_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rc_token", data.token);
    localStorage.setItem("rc_role", data.user.role);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("rc_token", data.token);
    localStorage.setItem("rc_role", data.user.role);
    setUser(data.user);
    return data.user;
  };

  const finishGoogle = (data) => {
    localStorage.setItem("rc_token", data.token);
    localStorage.setItem("rc_role", data.user.role);
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("rc_token");
    localStorage.removeItem("rc_role");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, finishGoogle, checkAuth, apiError }}>
      {children}
    </AuthCtx.Provider>
  );
}
